import React from 'react'
import useGlobalHook from 'use-global-hook'
import {initialState} from './store-config'
import actions from './actions/actions-config'

const useGlobal = useGlobalHook(React, initialState, actions);

export default useGlobal;
